const OAuthError = () => {
  return <></>;
};

export default OAuthError;
